import { createSvgIcon } from '@material-ui/core/utils';

export const PoliciesIcon = createSvgIcon(
  <>
    <path d="M19.76 3.95c-2.44-.71-4.81-1.68-7-2.86C12.3.8 11.7.8 11.28 1.07c-2.23 1.2-4.6 2.17-7.05 2.89-.61.19-1.02.77-.99 1.41l.26 7.99c.53 3.57 4.51 6.71 6.84 8.26.49.33 1.07.5 1.66.5s1.17-.17 1.66-.5c2.33-1.55 6.31-4.7 6.85-8.35l.25-7.9c.03-.64-.38-1.22-1-1.42Zm-3.1 5.22-4.79 4.99a.71.71 0 0 1-.53.22h-.05a.737.737 0 0 1-.55-.29l-1.99-2.67a.72.72 0 0 1-.14-.44.737.737 0 0 1 1.33-.44l1.47 1.97 4.18-4.37c.29-.29.75-.3 1.05-.02.29.29.3.75.02 1.05Z" />
  </>,
  'PoliciesIcon',
);
